<div style="vertical-align: top; margin: 20px; padding-bottom: 20px; min-height: 70px; min-width: 800px;">
  <form class="validation-form" novalidate>
    <div class="ui-g ui-fluid">
      <div class="ui-g-12">
        <label style="float: left; margin-right: 10px;">
          6 ostatnich cyfr numeru biletu / zeskanowany kod QR:
        </label>
        <input pInputText name="partTicketNumber" [(ngModel)]="partTicketNumber" (keyup)="searchTicket()" />
      </div>
    </div>
    <ng-container *ngIf="tickets.length > 0">
      <div style="margin: 10px;">Bilety:</div>
    </ng-container>

    <button pButton class="ticket-btn" *ngFor="let ticket of tickets" (click)="selectTicket(ticket)" label="{{ ticket }}"></button>

    <div *ngIf="errorMsg" class="error">{{ errorMsg }}</div>
    <div *ngIf="infoMsg" class="info">{{ infoMsg }}</div>

    <ng-container *ngIf="result != null">
      <br><br><br>
      Pełna należność za pobyt: <strong>{{ result }} PLN.</strong>
      <hr>
      <div *ngFor="let conf of configs" style="clear: both; padding: 10px; margin: 3px;">
        <button pButton [disabled]="loading" style="float: right; width: 50%; margin-left: 20px;" (click)="validate(conf)" title="{{ conf.description }}" label="{{ conf.name }}"></button>
        <span style="float: right;" *ngIf="conf.validationProvider.featureParametersMap != null && conf.validationProvider.featureParametersMap[2] != null">
          {{conf.validationProvider.featureParametersMap[2].value}}<sup *ngIf="conf.validationProvider.featureParametersMap != null && conf.validationProvider.featureParametersMap[3].value == 'true'">*</sup>:
          <input pInputText name="id" [(ngModel)]="addedInfo[conf.id]" />
        </span>
      </div>
    </ng-container>
  </form>
</div>
